var ezdia;
(function (ezdia) {
    function getQuickActionItems(id, items) {
        return "\n    <ul\n      id=\"" + id + "-dd\"\n      class=\"dropdown-menu dropdown-menu-right quick-actions-dropdown-menu\"\n      role=\"menu\"\n      style=\"max-height: 250px; overflow: auto\">\n      " + ezdia.templates.quickActions.genQAItem({ links: items }) + "\n    </ul>";
    }
    function actionBtnsGroup(btnsArray) {
        var btns = btnsArray.map(function (_a) {
            var id = _a.id, title = _a.title, icon = _a.icon, items = _a.items, cls = _a.cls;
            return "<button\n        " + (items ? "data-toggle=\"dropdown\"" : '') + "\n        type=\"button\"\n        class=\"btn btn-default " + (cls || '') + "\"\n        id=\"" + id + "\"\n        title=\"" + title + "\">\n        <i class=\"fa " + icon + "\"></i><span>" + title + "</span>\n      </button>\n      " + (items ? getQuickActionItems(id, items) : '');
        });
        return "<div class=\"ez-grid-action-btns-group\">\n      " + btns.join('') + "\n    </div>";
    }
    function countAndSelectCaption(recordCount) {
        return "<div class='checkbox grid-select-all-item'>\n      <label><input type='checkbox' id='selectAll' name='selectAll' onclick='selectAllClick(event)'/> Select all " + recordCount + " items </label>\n    </div>";
    }
    function caption(captionContent) {
        return "<div class=\"ez-grid-captions-action\">\n      <div class='ez-js-grid-caption-text'>" + captionContent + "</div>\n      <div id='ez-js-grid-actions-btns' class=\"ez-grid-actions-btns\">\n      </div>\n    </div>";
    }
    function allSelectedIdsBtn(_a) {
        var _b = _a.btnId, btnId = _b === void 0 ? 'ez-js-copy-field-btn' : _b, _c = _a.inputboxId, inputboxId = _c === void 0 ? 'ez-js-copy-field' : _c, _d = _a.btnTitle, btnTitle = _d === void 0 ? 'Copy all ids' : _d;
        return "\n      <button id=\"" + btnId + "\" data-button=\"copy\" type=\"button\" class=\"btn btn-link copy-ids\" title=\"" + btnTitle + "\"><i class=\"fa fa-copy\"></i></button>\n      <input class=\"copy-text-box\" type=\"text\" id=\"" + inputboxId + "\" />\n    ";
    }
    var templates;
    (function (templates) {
        templates.grid = {
            actionBtnsGroup: actionBtnsGroup,
            countAndSelectCaption: countAndSelectCaption,
            caption: caption,
            allSelectedIdsBtn: allSelectedIdsBtn
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
